import type { BankAccountIdentifierValueRes } from '@dealstack/shared/lib/generated';
import { BankAccountStatus } from '@dealstack/shared/lib/generated';
import { BANK_ACCOUNT_FIELD_TO_IDENTIFIER_KEY } from '@dealstack/shared/lib/common/business/bankAccountIdentifiers';
import { getIdentifierRows } from '@dealstack/frontend/shared/utils/bankAccountDisplay.utils.ts';

// The tile renders the IBAN on its own classic line, so it is the one identifying value
// the rows leave out; the bank name and the holder are already dropped upstream.
export const getTileIdentifierRows = (
	identifiers: BankAccountIdentifierValueRes[] | undefined
): BankAccountIdentifierValueRes[] =>
	getIdentifierRows(identifiers).filter(
		({ key }) => key !== BANK_ACCOUNT_FIELD_TO_IDENTIFIER_KEY.iban
	);

export const STATUS_BADGES: Record<BankAccountStatus, { labelKey: string; color: string }> = {
	[BankAccountStatus.DRAFT]: { labelKey: 'bank_account_tile.status.draft', color: 'gray' },
	[BankAccountStatus.INVESTOR_OTP_REQUESTED]: {
		labelKey: 'bank_account_tile.status.investor_otp_requested',
		color: 'orange',
	},
	[BankAccountStatus.INVESTOR_OTP_SUCCEEDED]: {
		labelKey: 'bank_account_tile.status.investor_otp_succeeded',
		color: 'teal',
	},
	[BankAccountStatus.INVESTOR_OTP_FAILED]: {
		labelKey: 'bank_account_tile.status.investor_otp_failed',
		color: 'red',
	},
	[BankAccountStatus.PENDING_VERIFICATION]: {
		labelKey: 'bank_account_tile.status.pending_verification',
		color: 'orange',
	},
	[BankAccountStatus.PENDING_ADMIN_REVIEW]: {
		labelKey: 'bank_account_tile.status.pending_admin_review',
		color: 'blue',
	},
	[BankAccountStatus.APPROVED]: { labelKey: 'bank_account_tile.status.approved', color: 'teal' },
	[BankAccountStatus.REJECTED]: { labelKey: 'bank_account_tile.status.rejected', color: 'red' },
	[BankAccountStatus.INACTIVE]: { labelKey: 'bank_account_tile.status.inactive', color: 'gray' },
};
